export default __webpack_public_path__ + "media/images/logos/nsc-logo-3b8b80e6dc42acc90186895fc45fdf78.png";